import { Component } from "react";
import * as React from "react";
import { Icon, PrimaryButton, TextField, Label, IconButton, IIconProps } from "office-ui-fabric-react";
import School from "../../../models/School";
import * as _ from "lodash";
import { MegaMenuPreview } from "./MegaMenuPreview";

export interface SchoolLogoCardProps {
    className?: string;
    school: School;
    currentLogo?: File
    onSchoolLogoChanged(updatedSchoolLogo: File | undefined, logoSet: boolean): void;
    megaMenuBgColour?: string
    megaMenuFontColour?: string
}

export interface SchoolLogoCardState {
    updatedLogo?: File
    logoName?: string
    logoError?: string
}

export class SchoolLogoCard extends Component<SchoolLogoCardProps, SchoolLogoCardState>
{
    readonly logoTypes: string[] = ["image/png", "image/jpeg", "image/gif", "image/svg+xml"];

    readonly maxFileSizeBytes: number = 1024 * 100; //100Kb

    constructor(props: Readonly<SchoolLogoCardProps>) {
        super(props);

        this.state = {
            updatedLogo: undefined,
            logoName: undefined,
            logoError: undefined
        };
    }

    componentDidUpdate(prevProps: Readonly<SchoolLogoCardProps>, prevState: Readonly<SchoolLogoCardState>, snapshot?: any): void {
    }

    public componentDidMount() {
    }

    imageDimensions = (file: File) => new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const { naturalWidth: width, naturalHeight: height } = img
            resolve({ width, height })
        };
        img.onerror = () => {
            reject('There was some problem with the image.')
        };
        img.src = URL.createObjectURL(file)
    })

    private fileChanged = async (e: any) => {

        this.setState({
            updatedLogo: undefined,
            logoName: undefined,
            logoError: undefined
        });

        if (e.target.files?.length == 1) {
            const file = e.target.files[0];

            if (file.size > this.maxFileSizeBytes) {
                this.props.onSchoolLogoChanged(undefined, false);
                this.setState({
                    logoError: "Logo must be less than 100KB.",
                    logoName: undefined,
                    updatedLogo: undefined
                });
            }
            else {
                this.props.onSchoolLogoChanged(file, true);
                this.setState({
                    updatedLogo: file,
                    logoName: file.name,
                    logoError: undefined
                });
            }
        }
    }

    private reset = async (e: any) => {
        this.props.onSchoolLogoChanged(undefined, this.props.currentLogo ? true : false);
        this.setState({
            updatedLogo: undefined,
            logoName: "",
        });
    }

    public render() {
        const cancelIcon: IIconProps = { iconName: 'Cancel' };

        return (
            <div className={`card ${this.props.className ? this.props.className : ""}`}>
                <div className="card__header">
                    <Icon iconName="Menu" className={"p-left-1rem"} />
                    <div className="card__title">
                        <span>Your School Logo</span>
                    </div>
                    {this.props.children}
                </div>
                <div className="card__flexcontent__column">
                    <TextField className="card__input file-input"
                        value={this.state.logoName}
                        label="Logo"
                        errorMessage={this.state.logoError ? this.state.logoError : ""}
                        readOnly
                        onRenderSuffix={() => {
                            return <IconButton style={{ height: "100%" }} iconProps={cancelIcon} onClick={this.reset} />
                        }}
                        onRenderPrefix={() => {
                            return <PrimaryButton>
                                <input id="logo-file"
                                    type="file"
                                    accept={this.logoTypes.join(", ")}
                                    onChange={this.fileChanged} />
                                <label htmlFor="logo-file">Choose a file</label>
                            </PrimaryButton>
                        }} />

                    <Label className="card__label">
                        <div className={"text-extra-detail"}>
                            Logo formats: {this.logoTypes.map(type => type.replace("image/", "")).join(", ")}
                        </div>
                    </Label>

                    <Label className="card__label">
                        <div className={"text-extra-detail"}>
                            Logo max file size: {this.maxFileSizeBytes / 1024}kb
                        </div>
                    </Label>

                    {this.state.updatedLogo ?
                        <div className="card__input">
                            <Label className="card__label">Preview Logo</Label>
                            <MegaMenuPreview megaMenuFontColour={this.props.megaMenuFontColour} megaMenuBgColour={this.props.megaMenuBgColour} megaMenuLogo={this.state.updatedLogo} />
                        </div>
                        : null}

                    {this.props.currentLogo ?
                        <div className="card__input">
                            <Label className="card__label">Current Logo</Label>
                            <MegaMenuPreview megaMenuFontColour={this.props.megaMenuFontColour} megaMenuBgColour={this.props.megaMenuBgColour} megaMenuLogo={this.props.currentLogo} />
                        </div>
                        : null}
                </div>
            </div>
        );
    }
}